import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SadMonster from '../common/EmptyListPlaceholder/SadMonster';
import GradebookSidebar from './sidebar/GradebookSidebar';
import { GradebookContainer } from './gradebookContainer/GradebookContainer';
import { PropTypes } from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import * as gradebookAction from '../../actions/classroom/gradebookActions';
import * as classroomApi from '../../services/api/classroomApi';
import * as classroomActions from '../../actions/classroom/classroomActions';
import { GRADEBOOK_SCOPE } from '../../const';
import Media from 'react-media';
import { MOBILE_MEDIA_QUERY } from '../../utils/mobileUtils';
import GradebookMobileFilterBar from './mobile/GradebookMobileFilterBar';

export class Gradebook extends React.Component {
  static propTypes = {
    routeParams: PropTypes.any,
    gradebookAction: PropTypes.any,
    gradebook: PropTypes.any,
    role: PropTypes.string,
    colors: PropTypes.any,
    selectedClassroom: PropTypes.any,
    connectionStatus: PropTypes.object
  };

  state = { groups: [] };

  componentDidMount() {
    this._ismounted = true;
    this.initGradebook().then(async () => {
      if (this._ismounted) {
        this.props.gradebookAction.getBooksData(this.props.routeParams?.idClassroom || this.props.idClassroom);
      }
    });

    classroomApi.getGroups(this.props.routeParams?.idClassroom || this.props.idClassroom).then(res => {
      if (this._ismounted) {
        this.setState({ groups: res.data });
      }
    });
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  async initGradebook() {
    const { gradebook, gradebookAction } = this.props;
    if (gradebook.selectedBook || gradebook.selectedLesson || gradebook.selectedUnit) {
      gradebookAction.setGradebookScope(GRADEBOOK_SCOPE.ACTIVITIES);

      gradebookAction.setBooksData([]);
      gradebookAction.setUnitsData([]);
      gradebookAction.setLessonsData([]);
      gradebookAction.setGrades();
    }
  }

  getSidebarProps() {
    const { gradebook, gradebookAction, colors, routeParams, selectedClassroom } = this.props;
    return {
      colors: colors,
      routeParams: routeParams || { idClassroom: this.props.idClassroom },
      books: gradebook.books,
      units: gradebook.units,
      lessons: gradebook.lessons,
      setGradebookScope: gradebookAction.setGradebookScope,
      selectedBook: gradebook.selectedBook,
      selectedUnit: gradebook.selectedUnit,
      selectedLesson: gradebook.selectedLesson,
      gradebookScope: gradebook.gradebookScope,
      setBookData: gradebookAction.setBookData,
      setUnitData: gradebookAction.setUnitData,
      setLessonData: gradebookAction.setLessonData,
      loadTasks: gradebookAction.loadTasks,
      sectionId: selectedClassroom.classroom.sectionId,
      setSelectedBook: gradebookAction.setSelectedBook,
      setSelectedUnit: gradebookAction.setSelectedUnit,
      setSelectedLesson: gradebookAction.setSelectedLesson,
      tasksFilterParams: gradebook.tasksFilterParams,
      changeTasksFilterParams: gradebookAction.changeTasksFilterParams
    };
  }

  getContainerProps() {
    const { gradebook, gradebookAction, colors, routeParams, selectedClassroom } = this.props;
    return {
      colors: colors,
      routeParams: routeParams || { idClassroom: this.props.idClassroom },
      books: gradebook.books,
      units: gradebook.units,
      lessons: gradebook.lessons,
      tasks: gradebook.tasks,
      gradebookScope: gradebook.gradebookScope,
      selectedBook: gradebook.selectedBook,
      selectedUnit: gradebook.selectedUnit,
      selectedLesson: gradebook.selectedLesson,
      setSelectedBook: gradebookAction.setBookData,
      setSelectedUnit: gradebookAction.setUnitData,
      setSelectedLesson: gradebookAction.setLessonData,
      sectionId: selectedClassroom.classroom.sectionId,
      activities: gradebook.activities,
      grades: gradebook.grades
    };
  }

  isTasksScope = () => this.props.gradebook.gradebookScope === GRADEBOOK_SCOPE.TASKS;

  render() {
    const { gradebook, selectedClassroom, connectionStatus, role } = this.props;

    if (!selectedClassroom.classroom.sectionId) return <div />;
    const className = connectionStatus.network ? 'gradebook' : 'gradebook offline';

    return (
      <div className={className}>
        <Media query={MOBILE_MEDIA_QUERY}>
          {isMobile =>
            isMobile ? (
              <GradebookMobileFilterBar {...this.getSidebarProps()} />
            ) : (
              <GradebookSidebar {...this.getSidebarProps()} />
            )
          }
        </Media>

        {gradebook.selectedBook || this.isTasksScope() ? (
          <GradebookContainer groups={this.state.groups} {...this.getContainerProps()} role={role} />
        ) : (
          <div className="gradebook sad-monster-container">
            <SadMonster msgKey={I18n.t('gradebook.noBook')} />
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Gradebook);

function mapStateToProps(state) {
  return {
    gradebook: state.gradebook,
    connectionStatus: state.connection.status,
    idClassroom: state.router.params.idClassroom,
    selectedClassroom: state.classrooms.selectedClassroom,
    colors: state.theme.colors,
    role: state.classrooms.selectedClassroom.classroom.role
  };
}

function mapDispatchToProps(dispatch) {
  return {
    gradebookAction: bindActionCreators(gradebookAction, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch)
  };
}
